import { cn, SegmentedControl, SegmentedControlSize } from "@quortex/front-common"
import { useSearch } from "@tanstack/react-location"
import type { MetricFilterProps } from "@/components/MetricFilter"
import type { MetricGenerics } from "@/types/metric"

const MetricFilter = ({ withUsage, withPercentage, className }: MetricFilterProps) => {
  const search = useSearch<MetricGenerics>()

  return (
    (withUsage || withPercentage) && (
      <SegmentedControl
        className={cn("mobile:col-span-3 justify-self-center", className)}
        segmentedControlList={[
          {
            active: search.metric === "viewers" || !search.metric,
            children: "Viewers",
            to: { search: (old: MetricGenerics["Search"]) => ({ ...old, metric: "viewers" }) }
          },
          ...(withUsage
            ? [
                {
                  active: search.metric === "usage",
                  children: "Usage",
                  to: { search: (old: MetricGenerics["Search"]) => ({ ...old, metric: "usage" }) }
                }
              ]
            : []),
          ...(withPercentage
            ? [
                {
                  active: search.metric === "percentage",
                  children: "%",
                  to: {
                    search: (old: MetricGenerics["Search"]) => ({ ...old, metric: "percentage" })
                  }
                }
              ]
            : [])
        ]}
        size={SegmentedControlSize.SMALL}
      />
    )
  )
}

export default MetricFilter
